import * as S from '@effect/schema/Schema';
export var TextBlockConfig = S.struct({
  typename: S.literal('TextBlock'),
  id: S.string,
  hash: S.string,
  text: S.string
});